import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 795CD51D-0887-4AC1-B7C1-137248AE0EB3
 * name sticker-alert-outline
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sticker-alert-outline.svg
 * tags
 * - Alert / Error 
 */
export const StickerAlertOutlineIcon = createSvgIcon(<><path d="M11 15H13V17H11V15M11 13H13V7H11V13M22 5.5V16L16 22H5.5C3.6 22 2 20.4 2 18.5V5.5C2 3.6 3.6 2 5.5 2H18.5C20.4 2 22 3.6 22 5.5M20 5.8C20 4.8 19.2 4 18.2 4H5.8C4.8 4 4 4.8 4 5.8V18.3C4 19.3 4.8 20.1 5.8 20.1H15V18.6C15 16.7 16.6 15.1 18.5 15.1H20V5.8Z" /></>, 'StickerAlertOutlineIcon');
export default StickerAlertOutlineIcon